// extracted by mini-css-extract-plugin
var _1 = "AITextGenerationFormFieldsTopRow-modulepromptTextarea__XY6NZ";
var _2 = "AITextGenerationFormFieldsTopRow-modulepromptTextareaWrap__WBxrS";
var _3 = "AITextGenerationFormFieldsTopRow-moduletopRow__W_IaD";
export { _1 as "promptTextarea", _2 as "promptTextareaWrap", _3 as "topRow" }
